import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { PermissionService } from 'app/core/services/permission.service';
import { ApiService } from 'app/shared/apis/api.service';
import { UserModel } from 'app/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
    selector: '[hasPermission]',
    standalone: true,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _permission: string | string[] = '';
    private _requireAll: boolean = false;

    @Input()
    set hasPermission(permission: string | string[]) {
        this._permission = permission;
        this.updateView();
    }

    @Input()
    set hasPermissionRequireAll(requireAll: boolean) {
        this._requireAll = requireAll;
        this.updateView();
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionService: PermissionService,
    ) {}

    ngOnInit(): void {
        // Subscrever a mudanças no usuário atual
        ApiService.userCurrent.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.updateView();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private updateView(): void {
        const hasPermission = this.checkPermission();

        // Sempre limpar antes de criar uma nova view para evitar duplicação
        this.viewContainer.clear();

        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private checkPermission(): boolean {
        if (!this._permission) {
            return true; // Se não especificar permissão, sempre mostra
        }

        if (Array.isArray(this._permission)) {
            if (this._requireAll) {
                return this.permissionService.hasAllPermissions(this._permission);
            } else {
                return this.permissionService.hasAnyPermission(this._permission);
            }
        } else {
            return this.permissionService.hasPermission(this._permission);
        }
    }
}



